import { getSettingsUrl } from '../lib/getSettingsURL';
import { Config, ConfigSchema } from '../hooks/Runtime';

const getDynamicConfig = async () => {
  if (window.config) {
    return { config: window.config!, response: new Response(null, { status: 200 }) };
  }

  try {
    const response = await fetch(getSettingsUrl());
    const config: Config = await response.json();
    const formattedConfig = ConfigSchema.parse(makeKeysUpperCase(config));

    return { config: formattedConfig as Config, response };
  } catch (error) {
    throw error instanceof Error ? error : new Error(String(error));
  }
};

function makeKeysUpperCase(config: Config) {
  return Object.fromEntries(Object.entries(config).map(([key, value]) => [key.toUpperCase(), value]));
}

export { getDynamicConfig, makeKeysUpperCase };
